export namespace ProductMasterDataTranslations {
  export const common = {
    productMasterData: 'productMasterData',
    purchasePrice: 'purchasePrice',
    sellingPrice: 'sellingPrice',
    totalPurchasePrice: 'totalPurchasePrice',
    totalSellingPrice: 'totalSellingPrice',
    metric: 'metric',
    dimensions: 'dimensions',
    price: 'price',
    productManagement: 'productManagement',
  } as const;

  export const error = {
    productMasterDataUnableToLoadError: 'productMasterDataUnableToLoadError',
    productMasterDataImportConfigurationDataUnableToLoadError:
      'productMasterDataImportConfigurationDataUnableToLoadError',
    productMasterDataExportConfigurationsUnableToLoadError: 'productMasterDataExportConfigurationsUnableToLoadError',
    productMasterDataKitManagedUnitTypeMustBeQuantityError: 'productMasterDataKitManagedUnitTypeMustBeQuantityError',
    productMasterDataManagedTypeChangeForKitWithExistingKitTemplateError:
      'productMasterDataManagedTypeChangeForKitWithExistingKitTemplateError',
    productMasterDataManagedTypeChangeNotAllowed: 'productMasterDataManagedTypeChangeNotAllowed',
  } as const;

  export const exportConfigurations = {
    productMasterDataExportConfigurationDeleteConfirmationText:
      'productMasterDataExportConfigurationDeleteConfirmationText',
  } as const;

  export const toast = {
    labelRemovedSuccessfullyToastTitle: 'labelRemovedSuccessfullyToastTitle',
  } as const;

  export const importConfigurations = {
    productMasterDataImportConfigurationCreateTitle: 'productMasterDataImportConfigurationCreateTitle',

    productMasterDataImportConfigurationNameLabel: 'productMasterDataImportConfigurationNameLabel',
    productMasterDataImportConfigurationNamePlaceholder: 'productMasterDataImportConfigurationNamePlaceholder',
    productMasterDataImportConfigurationHeaderSelectPlaceholder:
      'productMasterDataImportConfigurationHeaderSelectPlaceholder',
    productMasterDataImportConfigurationUploadTitle: 'productMasterDataImportConfigurationUploadTitle',
    productMasterDataImportConfigurationUploadSucessfulTitle:
      'productMasterDataImportConfigurationUploadSuccessfulTitle',
    productMasterDataImportConfigurationUploadSucessfulContent:
      'productMasterDataImportConfigurationUploadSucessfulContent',
  } as const;
}
